/*
 * @Description:
 * @Author: zhanjunwei
 * @Date: 2024-12-04 10:39:28
 * @LastEditors: zhanjunwei
 * @LastEditTime: 2025-02-10 15:20:06
 */
'use client';
import { NavTabs } from './NavTabs';
import { Logo } from '../../logo';
import { useRouter } from 'next/navigation';
import {
  useLocalGlobalStore,
  showChangeTeamModal,
  handleLogout,
} from '@ssv-website/hooks';
import { menus, LinkHref, getMenuList } from '../config';
import {
  MoreIcon,
  PoweroffIcon,
  UserIcon,
  ChevronDownIcon,
  SwapIcon,
  ChatIcon,
} from 'tdesign-icons-react';
import './index.css';
import { useMemo } from 'react';
import { isSimpleUrl } from '../../ssv-link';
import { openConferenceChatEntry } from '../conferenceChat';

export const LoginBar = ({
  title,
  onLogout,
}: {
  title: string | React.ReactNode;
  onLogout?: () => void;
}) => {
  const {
    currentIdentity: { teamType },
    hasTeam,
  } = useLocalGlobalStore((s) => s);
  const goAccount = () => {
    // 1 个人 2团队
    const url = teamType === 2 ? LinkHref.TeamAccount : LinkHref.Account;
    window.location.href = url;
  };
  const list = useMemo(() => {
    const defaultList = [
      {
        label: '进入账号中心',
        icon: <UserIcon size={16} className="font-500" />,
        click: goAccount,
      },
    ];
    if (teamType === 2 || hasTeam) {
      defaultList.push({
        label: '切换团队',
        icon: <SwapIcon size={16} className="font-500" />,
        click: () => showChangeTeamModal({ isLogin: false, closeBtn: true }),
      });
    }
    defaultList.push({
      label: '会聊',
      icon: <ChatIcon size={16} className="font-500" />,
      // 个人中心会聊入口只在登录后展示；是否可进入仍由权限接口实时判断。
      click: () => void openConferenceChatEntry(),
    });
    defaultList.push({
      label: '退出',
      icon: <PoweroffIcon size={16} className="font-500" />,
      click: onLogout ?? handleLogout,
    });

    return defaultList;
  }, [teamType, hasTeam, onLogout]);
  return (
    <div className="flex justify-end items-center min-w-[50px] relative overflow-hidden cursor-pointer hover:bg-[#F3F5F7] group hover:overflow-visible pl-[12px] rounded-[4px]">
      <UserIcon className="mr-2" size={16} />
      <div className={`text-[16px] text-primary text-nowrap`}>{title}</div>
      <div className="h-full flex items-center">
        <div
          className="w-[24px] ml-[4px] flex justify-center items-center"
          style={{ height: '30px' }}
        >
          <MoreIcon className="text-[16px]" />
        </div>
      </div>
      {/* 下拉菜单 */}
      <div className="absolute overflow-hidden right-0 min-w-[154px] h-0 pt-[28px] top-full transition-all duration-500 group-hover:h-[332px] group-hover:block">
        <div className="bg-white rounded-md py-[28px] shadow-card">
          {list.map((el) => (
            <div
              key={el.label}
              className="text-[14px] leading-[24px] text-primary hover:text-active flex justify-start items-center py-[8px] pl-[20px] relative bule-hover"
              onClick={el.click}
            >
              {el.icon}
              <div className="ml-[8px]">{el.label}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

const LoginBtn: React.FC<{ cs_text?: string; onLogout?: () => void }> = ({
  cs_text,
  onLogout,
}) => {
  const router = useRouter();
  const { userName, is_login } = useLocalGlobalStore((s) => s);
  const loginTextClass = cs_text || 'text-primary';
  const handleGo = () => {
    if (typeof window !== 'undefined' && process.env.NEXT_PUBLIC_BASE_PATH) {
      window.location.href = `/login?s_url=${encodeURIComponent(
        window.location.href
      )}`;
    } else {
      router.push(`/login?s_url=${encodeURIComponent(window.location.href)}`);
    }
  };
  if (is_login) {
    return <LoginBar title={userName} onLogout={onLogout} />;
  }
  return (
    <div className="flex items-center justify-end w-[150px]">
      <button
        type="button"
        onClick={handleGo}
        className={`text-[16px] leading-6 ${loginTextClass} hover:text-active text-nowrap text-end cursor-pointer bg-transparent border-0 p-0`}
      >
        登录
      </button>
    </div>
  );
};
interface IProps {
  rootClassName?: string;
  cssBox?: string;
  boxStyle?: React.CSSProperties;
  type?: 'white' | 'transparent';
  title?: string;
  isAdmin?: boolean;
  // 自定义退出行为；不传则默认跳 /login
  onLogout?: () => void;
}
// 透明主题、白底黑字主题
const typeMap = {
  transparent: { box: 'bg-white/0', text: 'text-white', line: 'bg-white' },
  white: {
    box: 'bg-white/100',
    text: 'text-black',
    line: 'bg-black',
  },
};
export const PCNavbar: React.FC<IProps> = (props) => {
  const {
    cssBox,
    boxStyle,
    type = 'white',
    title,
    isAdmin,
    onLogout,
    rootClassName = '',
  } = props;
  const css = typeMap[type];
  const goHome = () => {
    window.location.href = window.location.origin + '/';
  };

  const jumpToPage = (href: string | undefined) => {
    if (href) {
      // 判断是否为完整链接
      const isAllUrl = isSimpleUrl(href);
      window.location.href = isAllUrl
        ? href
        : `${window.location.origin}${href}`;
    }
  };

  const menusList = getMenuList();
  const positionCss = isAdmin ? 'pr-64 pl-8' : 'max-w-[1024px]';

  return (
    <div
      className={`relative h-[72px] z-50 flex-shrink-0 w-full mobile:hidden ${rootClassName}`}
    >
      <div
        id="pc-navbar"
        className={`fixed left-0 top-0 flex z-50 w-full h-[72px] justify-center ${cssBox} ${css?.box}`}
        style={boxStyle}
      >
        <div
          className={`flex items-center justify-between  w-full h-full desktop:px-5 ${positionCss}`}
        >
          {title ? (
            <div className="flex justify-start items-center">
              <div className="flex justify-start items-center cursor-pointer hover:bg-[#F3F5F7] px-[8px] py-[4px] rounded-sm relative z-[60] group overflow-hidden hover:overflow-visible ">
                <Logo type={type} />
                <ChevronDownIcon className="text-xl font-bold text-[#C0CBD5] ml-[4px]" />
                <div className="absolute overflow-hidden left-0 h-0 pt-[28px] top-full transition-all duration-500 group-hover:h-auto group-hover:block shadow-btn3">
                  <div className="bg-white rounded-md py-[30px] flex justify-start">
                    {menusList.map((items, index) => (
                      <div
                        key={index}
                        className={`${
                          index !== menusList.length - 1
                            ? 'border-r-[1px] border-r-[#353f4936]'
                            : ''
                        }`}
                      >
                        {items.map((el) => (
                          <div
                            key={el.label}
                            onClick={() => jumpToPage(el.link)}
                            className={`relative py-[8px] px-[30px] whitespace-nowrap ${
                              el.isTitle
                                ? 'text-[16px] font-700 cursor-default'
                                : 'bule-hover cursor-pointer text-[14px] font-400'
                            } `}
                          >
                            {el.label}
                          </div>
                        ))}
                      </div>
                    ))}
                  </div>
                </div>
              </div>
              <div className="w-[1px] h-6 bg-[#353F49]/20 ml-[10px] mr-5" />
              <div className="text-base font-bold">{title}</div>
            </div>
          ) : (
            <>
              <div
                onClick={goHome}
                className="flex justify-start items-center cursor-pointer"
              >
                <Logo type={type} />
              </div>
              <NavTabs data={menus} cssText={css.text} cssLine={css.line} />
            </>
          )}
          <LoginBtn cs_text={css.text} onLogout={onLogout} />
        </div>
      </div>
    </div>
  );
};
